module.exports = __webpack_public_path__ + "img/bv.3f45dc93.svg";